
  <button
    class=" ms-1"
    mat-stroked-button
    (click)="downloadReport()">
    Excel Report
  </button>
